export type StoredDocumentEntry =
  | string
  | {
      name?: string;
    }
  | null
  | undefined;

export const extractDocumentFileName = (document: StoredDocumentEntry): string => {
  if (typeof document === 'string') {
    const extractedName = document.split('/').pop()?.split('?')[0] || document;

    try {
      return decodeURIComponent(extractedName);
    } catch (_error) {
      return extractedName;
    }
  }

  if (document && typeof document.name === 'string') {
    return document.name;
  }

  return '';
};

export const hasDuplicateDocumentName = (
  documents: StoredDocumentEntry[],
  file?: {
    name?: string;
  } | null
): boolean => {
  const fileName = typeof file?.name === 'string' ? file.name : '';

  if (!fileName) {
    return false;
  }

  return documents.some(document => extractDocumentFileName(document) === fileName);
};
